module.exports = __webpack_public_path__ + "intro.ffe21f58.svg";